import {RatingFilter} from './rating.filter';
import { Injectable } from "@angular/core";

@Injectable()
export class SingleRatingFilter extends RatingFilter {
    public onFilterApplied(data: any, selectedRating: any): boolean {
        return super.onFilterApplied(data, [selectedRating]);
    }

    public identifier(): string {
        return 'SingleRatingFilter';
    }
}